import React from 'react'
import '../containers/TechSupport.css'
import { Typography, Grid, Stack, Paper } from '@mui/material'
import { MailOutline, Call, LocationOn, AccessTime } from '@mui/icons-material'
import { FormattedMessage } from 'react-intl'

export default function TechSupportContactEU() {
  return (
    <div className='ts-wrapper'>
      <Typography gutterBottom>
        <FormattedMessage id='support.internationalOffice' /> (
        <FormattedMessage id='support.internationalOffice.countries' />
        ):
      </Typography>
      <Stack spacing={2}>
        <Paper className='ts-paper'>
          <Grid container>
            <Grid item xs={4} className='ts-title-wrapper'>
              <div className='ts-title'>
                <MailOutline color='primary' className='ts-icon' />
                <Typography variant='h6'>
                  <FormattedMessage id='support.emailUs' />
                </Typography>
              </div>
            </Grid>
            <Grid item xs>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.generalInquiries' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>info@gemvision.com</Typography>
                </li>
              </ul>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.technicalSupport' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>support@gemvision.com</Typography>
                </li>
              </ul>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.training' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>training@gemvision.com</Typography>
                </li>
              </ul>
              <Typography variant='body2'>
                * <FormattedMessage id='support.contactDealer' />
              </Typography>
            </Grid>
          </Grid>
        </Paper>
        <Paper className='ts-paper'>
          <Grid container>
            <Grid item xs={4} className='ts-title-wrapper'>
              <div className='ts-title'>
                <Call color='primary' className='ts-icon' />
                <Typography variant='h6'>
                  <FormattedMessage id='support.callUs' />
                </Typography>
              </div>
            </Grid>
            <Grid item xs>
              <Typography variant='subtitle2'>Gemvision</Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>+34 937 547 774</Typography>
                </li>
                <li>
                  <Typography>
                    +34 937 547 774 ext 2
                    <span className='ts-span'>
                      (<FormattedMessage id='support.generalInquiries' />)
                    </span>
                  </Typography>
                </li>
                <li>
                  <Typography>
                    +34 937 547 774 ext 3
                    <span className='ts-span'>
                      (<FormattedMessage id='support.technicalSupport' />)
                    </span>
                  </Typography>
                </li>
              </ul>
              <Typography variant='subtitle2'>Stuller</Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>
                    +34 937 547 774 ext 1
                    <span className='ts-span'>
                      (<FormattedMessage id='support.europeCustomerCare' />)
                    </span>
                  </Typography>
                </li>
                <li>
                  <Typography>+34 722 687 266</Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Paper>
        <Paper className='ts-paper'>
          <Grid container>
            <Grid item xs={4} className='ts-title-wrapper'>
              <div className='ts-title'>
                <LocationOn color='primary' className='ts-icon' />
                <Typography variant='h6'>
                  <FormattedMessage id='support.directions' />
                </Typography>
              </div>
            </Grid>
            <Grid item xs>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.address' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>Moll de Ponent s/n, Mataró (08304), Barcelona, Spain</Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Paper>
        <Paper className='ts-paper'>
          <Grid container>
            <Grid item xs={4} className='ts-title-wrapper'>
              <div className='ts-title'>
                <AccessTime color='primary' className='ts-icon' />
                <Typography variant='h6'>
                  <FormattedMessage id='support.schedules' />
                </Typography>
              </div>
            </Grid>
            <Grid item xs>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.hoursEuropean' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>
                    <FormattedMessage id='support.monday_thursday' />, 8: 30 <small>AM</small> - 6: 00 <small>PM</small>
                    <span className='ts-span'>(UTC+1)</span>
                  </Typography>
                </li>
                <li>
                  <Typography>
                    <FormattedMessage id='support.friday' />, 8: 00 <small>AM</small> - 2: 00 <small>PM</small>
                    <span className='ts-span'>(UTC+1)</span>
                  </Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Paper>
      </Stack>
    </div>
  )
}
